export default {
    data: () => ({
        translations: {
            title: {
                el: "Όριο ποσού συναλλαγής",
                en: "Transaction Amount Limit",
                it: "Limite dell'importo della transazione"
            },
            description: {
                el: "Παρακαλώ ορίστε το ελάχιστο και μέγιστο όριο συνολικού ποσού που θέλετε να ισχύει για κάθε συναλαγή, προκειμένου να αποδοθούν πόντοι.",
                en: "Please set the minimum and maximum total amount you want to apply to each transaction in order to award points.",
                it: "Si prega di impostare l'importo minimo e massimo totale che si desidera applicare a ciascuna transazione per assegnare i punti."

            },
            description2: {
                el: "Αφήστε κενό ή πληκτρολογήστε μηδέν (0) για \"χωρίς όριο\".",
                en: 'Leave empty or type zero (0) for "no limit"',
                it: "Lasciare vuoto o digitare zero (0) per non avere limiti."
            },
            max: {
                el: "Μέγιστο ποσό",
                en: "Maximum amount",
                it: "Importo massimo"
            },
            min: {
                el: "Ελάχιστο ποσό",
                en: "Minimum amount",
                it: "Importo minimo"
            },
            maxMinError: {
                el: "Το μέγιστο ποσό πρέπει να είναι μεγαλύτερος αριθμός από το ελάχιστο ποσό.",
                en: "Maximum amount must be a higher number than the minimum amount",
                it: "L'importo massimo deve essere superiore all'importo minimo."
            },
            negativeAmountError: {
                el: "Και τα δύο ποσά πρέπει να είναι ίσα ή μεγαλύτερα του μηδενός.",
                en: "Both the amounts must be equal to or higher than zero.",
                it: "Entrambi gli importi devono essere pari o superiori a zero."
            },
        }
    })
};
